import { BrowserRouter, Route, Routes } from 'react-router-dom'

import styles from 'app/App.module.scss'
import { HomePage } from 'pages/welcome/HomePage'

export function App() {
  return (
    <BrowserRouter basename="/nma-gallery">
      <div className={styles.container}>
        {/* <Header /> */}
        <div className={styles.pageContent}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            {/* <Route path="/index" element={<IndexPage />} /> */}
            <Route path="/:category" element={<HomePage />} />
          </Routes>
        </div>
      </div>
    </BrowserRouter>
  )
}
